/**
 * Simple WebSocket test script
 * Run this in the browser console to test the WebSocket connection
 */

function testWebSocketConnection() {
  console.log('Testing WebSocket connection...');
  
  // Get WebSocket URL from environment or use the hardcoded one
  const wsUrl = process.env.REACT_APP_WEBSOCKET_URL || 'ws://4.206.213.237:8000/ws/dashboard';
  console.log('Using WebSocket URL:', wsUrl);
  
  // Create WebSocket connection
  try {
    const ws = new WebSocket(wsUrl);
    debugger;
    
    // Connection opened
    ws.addEventListener('open', (event) => {
      console.log('WebSocket connection established successfully!', event);
      // Wait for the server to send the connection_established message
      // Authentication will be handled in the message handler
    });
    
    // Listen for messages
    ws.addEventListener('message', (event) => {
      console.log('Message from server:', event.data);
      
      try {
        const data = JSON.parse(event.data);
        console.log('Parsed message data:', data);
        
        // If connection established, send authentication message
        if (data.type === 'connection_established') {
          console.log('Connection established, sending authentication message...');
          
          const authMessage = {
            type: 'authenticate',
            payload: {
              apiKey: 'koottu-dashboard-secret-key-2024'
            }
          };
          
          console.log('Authentication message:', JSON.stringify(authMessage));
          ws.send(JSON.stringify(authMessage));
        }
        
        // If authentication successful, send subscription message
        else if (data.type === 'authentication_successful' || data.type === 'authenticated' || data.type === 'auth_success') {
          console.log('Authentication successful, sending subscription message...');
          
          const subscribeMessage = {
            type: 'subscribe',
            payload: {
              metrics: [
                'active_users',
                'recent_activities',
                'recent_matches',
                'recent_subscriptions',
                'top_locations',
                'header_metrics',
                'user_growth',
                'match_analytics',
                'revenue_analytics',
                'user_demographics',
                'age_distribution',
                'gender_distribution'
              ],
              filters: {
                start_date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
                end_date: new Date().toISOString(),
                group_by: 'daily'
              }
            }
          };
          
          console.log('Subscription message:', JSON.stringify(subscribeMessage));
          ws.send(JSON.stringify(subscribeMessage));
          
          console.log('Waiting for subscription response and data updates (may take up to 30 seconds)...');
          
          // Request initial data after subscribing
          setTimeout(() => {
            console.log('Requesting initial data...');
            const requestDataMessage = {
              type: 'request_data',
              payload: {
                metrics: [
                  'active_users',
                  'recent_activities',
                  'recent_matches',
                  'recent_subscriptions',
                  'top_locations',
                  'header_metrics',
                  'user_growth',
                  'match_analytics',
                  'revenue_analytics',
                  'user_demographics',
                  'age_distribution',
                  'gender_distribution'
                ],
                filters: {
                  start_date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
                  end_date: new Date().toISOString(),
                  group_by: 'daily'
                }
              }
            };
            
            console.log('Request data message:', JSON.stringify(requestDataMessage));
            ws.send(JSON.stringify(requestDataMessage));
          }, 1000);
        }
        
        // If subscription successful, log it
        if (data.type === 'subscription_successful' || data.type === 'subscribed' || data.type === 'subscribe_success') {
          console.log('Subscription successful, waiting for data updates...');
        }
        
        // If we received a metric update, log it
        if (data.type === 'metric_update' || data.type === 'update') {
          console.log('Received metric update!');
          console.log('Update data:', data.data);
          
          // Log specific metrics if they exist
          if (data.data) {
            if (data.data.active_users) console.log('Active users:', data.data.active_users);
            if (data.data.activities) console.log('Activities:', data.data.activities.length);
            if (data.data.matches) console.log('Matches:', data.data.matches.length);
            if (data.data.subscriptions) console.log('Subscriptions:', data.data.subscriptions.length);
            if (data.data.locations) console.log('Locations:', data.data.locations.length);
            if (data.data.header_metrics) console.log('Header metrics:', data.data.header_metrics);
          }
        }
        // Handle specific data update types
        else if (data.type === 'active_users') {
          console.log('Received active users update:', data);
          const processedData = data.data || data.payload || {};
          console.log('Active users data:', processedData);
        }
        else if (data.type === 'recent_activities') {
          console.log('Received recent activities update:', data);
          const processedData = data.data || data.payload || [];
          console.log('Activities data:', processedData.length, 'items');
        }
        else if (data.type === 'recent_matches') {
          console.log('Received recent matches update:', data);
          const processedData = data.data || data.payload || [];
          console.log('Matches data:', processedData.length, 'items');
        }
        else if (data.type === 'recent_subscriptions') {
          console.log('Received recent subscriptions update:', data);
          const processedData = data.data || data.payload || [];
          console.log('Subscriptions data:', processedData.length, 'items');
        }
        else if (data.type === 'top_locations') {
          console.log('Received top locations update:', data);
          const processedData = data.data || data.payload || [];
          console.log('Locations data:', processedData.length, 'items');
        }
        else if (data.type === 'header_metrics') {
          console.log('Received header metrics update:', data);
          const processedData = data.data || data.payload || {};
          console.log('Header metrics data:', processedData);
        }
        else if (data.type === 'user_growth') {
          console.log('Received user growth update:', data);
          const processedData = data.data || data.payload || {};
          console.log('User growth data:', processedData);
        }
        else if (data.type === 'match_analytics') {
          console.log('Received match analytics update:', data);
          const processedData = data.data || data.payload || {};
          console.log('Match analytics data:', processedData);
        }
        else if (data.type === 'revenue_analytics') {
          console.log('Received revenue analytics update:', data);
          const processedData = data.data || data.payload || {};
          console.log('Revenue analytics data:', processedData);
        }
        else if (data.type === 'user_demographics') {
          console.log('Received user demographics update:', data);
          const processedData = data.data || data.payload || {};
          console.log('User demographics data:', processedData);
        }
        else if (data.type === 'age_distribution') {
          console.log('Received age distribution update:', data);
          const processedData = data.data || data.payload || {};
          console.log('Age distribution data:', processedData);
        }
        else if (data.type === 'gender_distribution') {
          console.log('Received gender distribution update:', data);
          const processedData = data.data || data.payload || {};
          console.log('Gender distribution data:', processedData);
        }
        else if (data.type === 'geographic_distribution') {
          console.log('Received geographic distribution update:', data);
          const processedData = data.data || data.payload || {};
          console.log('Geographic distribution data:', processedData);
        }
        
        // If we received a ping response, log it
        else if (data.type === 'pong' || data.type === 'ping_response') {
          console.log('Received ping response');
        }
        
        // If we received an error, log it
        else if (data.type === 'error') {
          console.error('Received error from server:', data);
        }
        
        // If we received an unknown message type, log it
        else if (data.type !== 'connection_established' && 
                data.type !== 'authentication_successful' && 
                data.type !== 'authenticated' && 
                data.type !== 'auth_success' &&
                data.type !== 'subscription_successful' && 
                data.type !== 'subscribed' && 
                data.type !== 'subscribe_success') {
          console.log('Received unknown message type:', data.type);
          // Try to handle the data anyway in case it contains useful information
          if (data.data) {
            console.log('Message data:', data.data);
          }
        }
      } catch (error) {
        console.error('Error parsing message:', error);
      }
    });
    
    // Connection closed
    ws.addEventListener('close', (event) => {
      console.log('WebSocket connection closed:', event);
      console.log('Close code:', event.code);
      console.log('Close reason:', event.reason);
      console.log('Clean close:', event.wasClean);
    });
    
    // Connection error
    ws.addEventListener('error', (event) => {
      console.error('WebSocket error:', event);
    });
    
    // Set up a ping interval to keep the connection alive
    const pingInterval = setInterval(() => {
      if (ws.readyState === WebSocket.OPEN) {
        console.log('Sending ping to keep connection alive');
        ws.send(JSON.stringify({ 
          type: 'ping', 
          payload: { 
            timestamp: Date.now() 
          }
        }));
      } else {
        console.log('WebSocket not open, cannot send ping');
        clearInterval(pingInterval);
      }
    }, 30000);
    
    // Return both the WebSocket and the ping interval for cleanup
    return {
      ws,
      pingInterval,
      cleanup: () => {
        clearInterval(pingInterval);
        if (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING) {
          ws.close();
        }
      }
    };
  } catch (error) {
    console.error('Error creating WebSocket:', error);
    return null;
  }
}

// Export the test function
export default testWebSocketConnection; 